"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchThreads = fetchThreads;
exports.initQuestionCloudInStore = initQuestionCloudInStore;
exports.isFirstMessageSend = isFirstMessageSend;
exports.saveInterventionsData = saveInterventionsData;
exports.saveMessage = saveMessage;
exports.saveMessages = saveMessages;
exports.saveQuestionsToStore = saveQuestionsToStore;
exports.saveSystemMessageData = saveSystemMessageData;
exports.saveThreads = saveThreads;
exports.setChatStatus = setChatStatus;
exports.setChatUnreadCounter = setChatUnreadCounter;
exports.showLoadMore = showLoadMore;
exports.toggleUnreadChats = toggleUnreadChats;
exports.updateThread = updateThread;
function showLoadMore(store, pageToken) {
  store.dispatch({
    type: 'SHOW_LOAD_MORE',
    data: {
      pageToken: pageToken
    }
  });
}
function toggleUnreadChats(store, count) {
  store.dispatch({
    type: 'TOGGLE_UNREAD_CHATS',
    data: count > 0
  });
}
function saveInterventionsData(store, data) {
  store.dispatch({
    type: 'SAVE_INTERVENTIONS_DATA',
    data: data
  });
}
function saveMessages(store, data) {
  store.dispatch({
    type: 'SAVE_MESSAGES',
    data: data
  });
}
function saveMessage(store, data) {
  store.dispatch({
    type: 'SAVE_MESSAGE',
    data: data
  });
}
function isFirstMessageSend(store, data) {
  store.dispatch({
    type: 'IS_FIRST_MESSAGE_SEND',
    data: data
  });
}
function saveThreads(store, data) {
  store.dispatch({
    type: 'SAVE_THREADS',
    data: data
  });
}
function fetchThreads(store) {
  store.dispatch({
    type: 'FETCH_THREADS'
  });
}
function updateThread(store, data) {
  store.dispatch({
    type: 'UPDATE_THREAD',
    data: data
  });
}
function setChatStatus(store, data) {
  store.dispatch({
    type: 'SET_CHAT_STATUS',
    data: data
  });
}
function setChatUnreadCounter(store, data) {
  store.dispatch({
    type: 'SET_TOTAL_UNREAD_COUNT',
    data: data
  });
}
function saveSystemMessageData(store, data) {
  store.dispatch({
    type: 'SAVE_SYSTEM_MESSAGE_DATA',
    data: data
  });
}
function saveQuestionsToStore(store, data) {
  store.dispatch({
    type: 'SAVE_QUESTIONS',
    data: data
  });
}
function initQuestionCloudInStore(store, data) {
  store.dispatch({
    type: 'INIT_QUESTION_CLOUD',
    data: data
  });
}